export default "__VITE_ASSET__nyyEFNZc__"